import { createContext } from 'react';
import type { LinkContextValue } from './types';

export const LinkContext = createContext<LinkContextValue | null>(null);
